import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Select from '@mui/material/Select'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import {KeyboardArrowDown} from '@mui/icons-material'
import Date from 'components/Date'
import {dateTypes, dateUnit, dateFromToday} from 'utils/enums/filters'

const Container = styled.div`
    box-sizing: border-box;
    height: 29px;
    align-items: center;
    position: relative;
    display: flex;

    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    }

    :hover {
        &:before {
            border-bottom: 2px solid #4a4a4a;
        }
    }
`

const Label = styled.div`
    font-weight: 400;
    border-radius: 2px;
    padding: 3px 10px;
    font-size: 13px;
    height: 24px;
    line-height: 24px;
    background-color: #415dd4;
    color: #fff;
`

const constantDateType = 2

class FilterDialogDate extends React.Component {
    constructor(props) {
        super(props)

        const dateValueType = this.props.value ? this.props.value.type === constantDateType ?
            dateTypes[this.props.value.value].code : this.props.value.type : dateTypes.exact.code

        this.state = {
            anchorEl: null,
            dateValueType,
            period: this.props.value && this.props.value.type === dateTypes.period.code ? this.props.value.value.period : dateUnit.days.code,
            direction:  this.props.value && this.props.value.type === dateTypes.period.code ? this.props.value.value.direction : dateFromToday.afterToday.code,
            offset: this.props.value && this.props.value.type === dateTypes.period.code ? Number(this.props.value.value.offset) : null,
            dateExactValue: this.props.value && this.props.value.type === dateTypes.exact.code ? this.props.value.value : null
        }
    }

    openDateMenu = event => {
        this.setState({ dateMenu: event.currentTarget })
    }

    closeDateMenu = () => {
        this.setState({ dateMenu: null })
    }

    changeType = (type) => {
        this.setState({ dateValueType: type }, () => this.handleUpdate())
        this.closeDateMenu()
    }

    changeDateValue = (e) => {
        const value = e.target.value ?
            e.target.name === 'period' ? e.target.value : Number(e.target.value) : null
            
        this.setState({
            [e.target.name]: value
        }, () => this.handleUpdate())
    }

    handleUpdate = () => {
        if (this.state.dateValueType === dateTypes.today.code) {
            this.props.changeValue({type: constantDateType, value: 'today'})
        } else if (this.state.dateValueType === dateTypes.monthstart.code) {
            this.props.changeValue({type: constantDateType, value: 'monthstart'})
        } else if (this.state.dateValueType === dateTypes.monthend.code) {
            this.props.changeValue({type: constantDateType, value: 'monthend'})
        } else if (this.state.dateValueType === dateTypes.exact.code) {
            this.props.changeValue({type: this.state.dateValueType, value: this.state.dateExactValue})
        } else {
            this.props.changeValue({
                type: this.state.dateValueType,
                value: {
                    offset: this.state.offset,
                    period: this.state.period,
                    direction: this.state.direction
                }
            })
        }
    }

    render() {
        const { intl, config } = this.props
        const index = config.type !== 'dateonly' ?
            config.format.indexOf('H') !== -1 ? config.format.indexOf('H') : config.format.indexOf('h') : null
        const format = index ? config.format.slice(0, index - 1) : config.format

        const dateConfig = {
            type: config.type,
            format: format,
            timezone: config.timezone
        }

        return (
            <React.Fragment>
                <React.Fragment>
                    {this.state.dateValueType === dateTypes.today.code ||
                    this.state.dateValueType === dateTypes.monthstart.code ||
                    this.state.dateValueType === dateTypes.monthend.code ?
                        <Label>{intl.formatMessage({id:`filter.${Object.values(dateTypes).find(item =>
                            item.code === this.state.dateValueType).label}`})}</Label>
                    : this.state.dateValueType === dateTypes.period.code ?
                        <React.Fragment>
                            <TextField variant="standard"
                                name='offset'
                                onChange={this.changeDateValue}
                                style={{ maxWidth: '50px', minWidth: '20px' }}
                                defaultValue={this.state.offset}
                                type='number'
                            />
                            <Select
                                style={{ margin: '0 5px' }}
                                value={this.state.period}
                                name='period'
                                onChange={this.changeDateValue}
								variant="standard"
                            >
                                {Object.values(dateUnit).map((item, index) =>
                                    <MenuItem key={index} value={item.code}>
                                        {intl.formatMessage({id: `filter.${item.label}`})}
                                    </MenuItem>
                                )}
                            </Select>
                            <Select
                                value={this.state.direction}
                                name='direction'
                                onChange={this.changeDateValue}
								variant="standard"
                            >
                                {Object.values(dateFromToday).map((item, index) =>
                                    <MenuItem key={index} value={item.code}>
                                        {intl.formatMessage({id: `filter.${item.label}`})}
                                    </MenuItem>
                                )}
                            </Select>
                        </React.Fragment>
                    :
                        <Container>
                            <Date
                                defaultValue={this.state.dateExactValue}
                                config={dateConfig}
                                name={this.props.name}
                                padding='0px'
                                handleUpdateValue={(value) => this.setState({ dateExactValue: value }, () => this.handleUpdate())}
                            />
                        </Container>
                    }
                    <KeyboardArrowDown
                        style={{ fontSize: 22, cursor: 'pointer', marginLeft: '10px' }}
                        onClick={this.openDateMenu}
                    />
                </React.Fragment>
                <Menu
                    anchorEl={this.state.dateMenu}
                    open={Boolean(this.state.dateMenu)}
                    onClose={this.closeDateMenu}
                >
                    {Object.values(dateTypes).map((item, index) =>
                        <MenuItem key={index} selected={item.code === this.state.dateValueType} onClick={() => this.changeType(item.code)}>
                            {intl.formatMessage({id: `filter.${item.label}`})}
                        </MenuItem>
                    )}
                </Menu>
            </React.Fragment>
        )
    }
}

export default injectIntl(FilterDialogDate)
